import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  Bugsnag.start({
    apiKey: 'bc34d614ab6780197ba62024730635de',
    plugins: [new BugsnagPluginVue()],
  })

  const bugsnagVue = Bugsnag.getPlugin('vue')

  if (bugsnagVue) {
    bugsnagVue.install(nuxtApp.vueApp)
  }
})
